import { Theme } from '@mui/material';

export type ColorHoverVariants =
    | 'black'
    | 'white'
    | 'grey400'
    | 'grey500'
    | 'grey800'
    | 'grey700'
    | 'primary'
    | 'primary2';

export const colorHoverVariants = (
    theme: Theme
): Record<ColorHoverVariants, { textColor: string; hoverColor: string }> => {
    return {
        black: { textColor: theme.palette.common.black, hoverColor: theme.palette.grey[700] },
        white: { textColor: theme.palette.common.white, hoverColor: theme.palette.grey[500] },
        grey400: { textColor: theme.palette.grey[400], hoverColor: theme.palette.common.white },
        grey500: { textColor: theme.palette.grey[500], hoverColor: theme.palette.common.white },
        grey700: { textColor: theme.palette.grey[700], hoverColor: theme.palette.common.black },
        grey800: { textColor: theme.palette.grey[800], hoverColor: theme.palette.common.black },
        primary: { textColor: theme.palette.common.black, hoverColor: theme.palette.primary.main },
        primary2: { textColor: theme.palette.primary.main, hoverColor: theme.palette.common.black },
    };
};
